export default {
  role: "Role",
  addRole: "AddRole",
  editRole: "EditRole",
};
